module.exports = __webpack_public_path__ + "media/images/products/app-store-ab0eaeb929fcf9be1a5be635d7755e08.svg";